module.exports = "<div class=\"panel panel-default\"> <div class=panel-body>{{'agreement.questionnaire.performance.review.first_turn' | translate}}</div> <div class=\"panel-footer text-center\"> <button-spinner button-class=\"btn btn-warning\" ng-click=\"!vm.active && vm.openConfirmAgreementTurnModal()\" active=vm.active state-normal-icon=\"fa fa-lock\" state-normal-text=\"'agreement.questionnaire.performance.review.first_turn.lock' | translate\"></button-spinner> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/performance-review/performance-review-agreement-lock/performance-review-agreement-lock.html
 ** module id = 260
 ** module chunks = 0
 **/